"use strict";
import { useCallback } from "react";
import { usePermissions } from "./usePermissions";
export function usePermissionChecker() {
  const [shellPermissions] = usePermissions();
  const shellPermissionsSet = new Set(shellPermissions);
  return useCallback(
    (permissions) => {
      if (typeof permissions === "string") return shellPermissionsSet.has(permissions);
      for (const permission of permissions) {
        if (!shellPermissionsSet.has(permission)) return false;
      }
      return true;
    },
    [shellPermissions]
  );
}
